import { Button, Container, Grid, TextField } from "@mui/material";
import Icon from "@mui/material/Icon";
import * as queryString from "query-string";
import React, { useEffect, useState } from "react";
import MultiSelect from "react-multi-select-component";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getRoleGroupbyID,
  getRoleFunctionList,
  getRoleMenuList,
  editRelation,
  seteditRelation,
} from "../../store/actions/roleGroupActions";
import CustomList from "../../components/List/CustomList";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import { useTranslation } from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";

function AddFunctionToRoleGroup() {
  const dispatch = useDispatch();
  const res = useSelector(({ roleGroup }) => roleGroup);
  const history = useHistory();
  let [data, setData] = useState([]);
  let [allFunctions, setAllFunctions] = useState([]);
  let [allMenus, setAllMenus] = useState([]);
  let [selectedFunctions, setSelectedFunctions] = useState([]);
  let [selectedMenus, setSelectedMenus] = useState([]);
  let [isSelectLoading, setSelectLoading] = useState([]);
  const [pageLoaded, setPageLoaded] = useState(false);
  const { t } = useTranslation("translation");

  useEffect(() => {
    LoadHandler();
  }, []);

  useEffect(() => {
    if (res.RoleGroupDetailbyID.errorCode === 0) {
      setData(res.RoleGroupDetailbyID.resultObject);
      setSelectedMenus(
        Object.values(res.RoleGroupDetailbyID.resultObject.menuList).map(
          (item, index) => ({
            label: item.description,
            value: item.id,
            name: item.description,
          })
        )
      );
      setSelectedFunctions(
        Object.values(res.RoleGroupDetailbyID.resultObject.functionList).map(
          (item, index) => ({
            label: item.description,
            value: item.id,
            name: item.description,
          })
        )
      );
    }
    if (res.RoleMenuList?.errorCode === 0) {
      setPageLoaded(true);
      setSelectLoading(false);
      setAllMenus(
        Object.values(res.RoleMenuList.resultObject).map((item, index) => ({
          label: item.description,
          value: item.id,
          name: item.description,
        }))
      );
      setSelectLoading(false);
    }
    if (res.RoleFunctionList?.errorCode === 0) {
      setAllFunctions(
        Object.values(res.RoleFunctionList.resultObject).map((item, index) => ({
          label: item.description,
          value: item.id,
          name: item.description,
        }))
      );
    }
    if (res.RoleEditRelation?.data?.errorCode === 0) {
      dispatch(seteditRelation(undefined));
      LoadHandler();
    }
    if (res.RoleEditRelation?.errorCode === 1) {
      dispatch(seteditRelation(undefined));
    }
  }, [res]);

  const LoadHandler = () => {
    setSelectLoading(true);
    dispatch(getRoleGroupbyID(queryString.parse(window.location.search).id));
    dispatch(getRoleFunctionList());
    dispatch(getRoleMenuList());
  };

  //add data
  const AddHandler = () => {
    const data = {
      roleGroupId: Number(queryString.parse(window.location.search).id),
      functionIdLst: selectedFunctions.map((item) => item.value),
      menuIdLst: selectedMenus.map((item) => item.value),
    };

    dispatch(editRelation(data));
  };

  const TurnBack = () => {
    history.goBack();
  };

  //override strings in multiselect
  const stringTR = {
    selectSomeItems: t("SelectSomeItems"),
    allItemsAreSelected: t("AllItemsAreSelected"),
    selectAll: t("SelectAll"),
    search: t("Search"),
  };

  return (
    <Container id="arg_Container" maxWidth="md">
      <h1>{t("RoleGroupInformation")}</h1>
      {pageLoaded ? (
        <Grid id="arg_Grid" container spacing={3}>
          <Grid id="arg_Grid_1" item xs={12} sm={6} md={6}>
            <TextField
              id="arg_TextField"
              label={t("RoleGroupCode")}
              value={data.code}
              InputProps={{
                readOnly: true,
              }}
              variant="outlined"
            />
          </Grid>
          <Grid id="arg_Grid_2" item xs={12} sm={6} md={6}>
            <TextField
              id="arg_TextField_1"
              label={t("RoleGroupName")}
              value={data.name}
              InputProps={{
                readOnly: true,
              }}
              variant="outlined"
            />
          </Grid>
          <Grid id="arg_Grid_3" item xs={6} sm={6}>
            <h4>{t("Functions")}</h4>
            <Autocomplete
              multiple
              id="arg_Autocomplete_1"
              options={allFunctions}
              limitTags={5}
              value={allFunctions.filter((item) =>
                Object.values(selectedFunctions)
                  .map((item) => {
                    return item.name;
                  })
                  .includes(item.name)
              )}
              disableCloseOnSelect={true}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  label={t("Functions")}
                  variant="outlined"
                  id="aug_table_TextField_0"
                />
              )}
              onChange={(event, newValue) => {
                setSelectedFunctions(newValue);
              }}
              renderOption={(_props, option) => (
                <li {..._props}>{option.name}</li>
              )}
              size={"normal"}
            />
          </Grid>
          <Grid id="arg_Grid_4" item xs={6} sm={6}>
            <pre style={{ marginTop: 25 }}>
              <CustomList
                id="arg_cl"
                dense={true}
                listItems={selectedFunctions}
                name="list1"
              />
            </pre>
          </Grid>
          <Grid id="arg_Grid_5" item xs={6} sm={6}>
            <h4>{t("Menus")}</h4>
            <Autocomplete
              multiple
              id="arg_Autocomplete_2"
              options={allMenus}
              limitTags={5}
              value={allMenus.filter((item) =>
                Object.values(selectedMenus)
                  .map((item) => {
                    return item.name;
                  })
                  .includes(item.name)
              )}
              disableCloseOnSelect={true}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  label={t("Menus")}
                  variant="outlined"
                  id="aug_table_TextField_0"
                />
              )}
              onChange={(event, newValue) => {
                setSelectedMenus(newValue);
              }}
              renderOption={(_props, option) => (
                <li {..._props}>{option.name}</li>
              )}
              size={"normal"}
            />
          </Grid>
          <Grid id="arg_Grid_6" item xs={6} sm={6}>
            <pre style={{ marginTop: 25 }}>
              <CustomList
                id="arg_cl_1"
                dense={true}
                listItems={selectedMenus}
                name="list2"
              />
            </pre>
          </Grid>
          <Grid
            id="arg_Grid_7"
            item
            xs={6}
            sm={6}
            style={{ textAlign: "left" }}
          >
            <Button
              id="arg_b"
              onClick={TurnBack}
              variant="contained"
              endIcon={<Icon>arrow_back</Icon>}
              style={{ marginRight: 15 }}
            >
              {t("TurnBack")}
            </Button>
            <Button
              id="arg_b_1"
              onClick={AddHandler}
              variant="contained"
              color="primary"
              endIcon={<Icon>check</Icon>}
            >
              {t("Save")}
            </Button>
          </Grid>
        </Grid>
      ) : null}
      <LoadingBackdrop id="arg_lbd" />
    </Container>
  );
}

export default AddFunctionToRoleGroup;
